module.exports = __webpack_public_path__ + "c2h4static/img/unstartTest.c84ebc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/unstartTest.png
// module id = MyL5
// module chunks = 1